import { Box, CircularProgress } from '@mui/material';

export const LoadingIndicator = () => (
  <Box display="flex" justifyContent="center" sx={{ height: '100%', overflow: 'hidden' }}>
    <Box display="flex" flexDirection="column" justifyContent="center" sx={{ overflow: 'hidden' }}>
      <CircularProgress />
    </Box>
  </Box>
);
